import dayjs from "dayjs";

import i18n from "../../translations/i18n";

export const parseErrorHelper = (e) => {
    
    if (e.message === "Network Error") {
        if (navigator.onLine) {
            // return new Promise((resolve) => {
            //     fetch("https://www.google.com/", { mode: "no-cors" })
            //     .then(() => resolve(i18n.t("MAINTENANCE_MODE")))
            //     .catch(() => resolve(i18n.t("NETWORK_ERROR")));
            // })
            return i18n.t("MAINTENANCE_MODE");
        } else {
            return i18n.t("NETWORK_ERROR");
        }
    } else {
        if (e.response) {
            if (e.response.status === 401) {
                return i18n.t("UNAUTHORIZED");
            } else if (e.response.status === 403) {
                return i18n.t("ERROR_NO_PERMISSION");
            } else if (e.response.status === 404) {
                return i18n.t("NOT_FOUND");
            } else if (e.response.status === 405) {
                return i18n.t("BAD_REQUEST");
            } else if (e.response.status === 469) {
                return i18n.t("ERROR_CODE_EXPIRED");
            } else if (e.response.status === 470) {
                return i18n.t("ERROR_INVALID_VERIFICATION_CODE");
            } else if (e.response.status === 500) {
                return i18n.t("SERVICE_ERROR");
            } else if (e.response.status === 585) {
                return i18n.t("ERROR_CONTACT_NOT_FOUND");
            } else {
                const message = e.response?.data?.message;
                if (message && message !== "Bad Request") return message;
                return i18n.t(e.response?.data?.code || "BAD_REQUEST");
            }
        } else {
            return i18n.t("SERVICE_ERROR");
        }
    }
};

export const validateEmailHelper = (email) => {
    const regex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
};

export const getUserNameHelper = (userData) => {
    if (!userData) return "";
    let userName =
        `${userData.firstname ? userData.firstname : ""} ` +
        `${userData.lastname1 ? userData.lastname1 : ""} ` +
        `${userData.lastname2 ? userData.lastname2 : ""}`;
    if (!userName || !userName.trim()) userName = userData.email;
    return userName ? userName.trim() : "-";
};

export const formatDateTimeHelper = (datetime, formatter = "MM/DD/YYYY HH:mm", isUTC = false) => {
    if (!datetime) return "";

    const language = localStorage.getItem("i18nextLng") || "en";
    if (formatter.includes("MM/DD") && !language.includes("en")) formatter = formatter.replace("MM/DD", "DD/MM");
    return isUTC
        ? dayjs(datetime).utc().locale(language).format(formatter)
        : dayjs(datetime).locale(language).format(formatter);
};

/** Relative time under 10 days; otherwise absolute datetime. */
export const formatCommentCreatedAtHelper = (createdAt, t) => {
    if (!createdAt) return "";
    const created = dayjs(createdAt);
    if (!created.isValid()) return "";

    const minutes = dayjs().diff(created, "minute");
    const hours = dayjs().diff(created, "hour");
    const days = dayjs().diff(created, "day");

    if (minutes < 0) return t("justNow");
    if (days >= 10) return formatDateTimeHelper(createdAt, "MMM DD YYYY, hh:mm A");
    if (minutes < 1) return t("justNow");
    if (minutes < 60) return t(minutes === 1 ? "minAgo" : "minsAgo", { count: minutes });
    if (hours < 24) return t(hours === 1 ? "hourAgo" : "hoursAgo", { count: hours });
    return t(days === 1 ? "dayAgo" : "daysAgo", { count: Math.max(days, 1) });
}

export const formatTicketNoHelper = (ticket) => {
    if (!ticket?.id) return "";
    const year = ticket.created_at ? dayjs(ticket.created_at).year() : dayjs().year();
    return `TCK-${year}-${String(ticket.id).padStart(4, "0")}`;
};

export const truncateTextHelper = (text, maxLength = 100) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
};

export const getObjectFromArray = (list, keyGetter) => {
    const object = {};
    if (!list) return object;
    list.forEach((item) => {
        const key = keyGetter(item);
        object[key] = item;
    });
    return object;
};

export const getPathnameHelper = (string) => {
    if (!string) return "";
    try {
        const url = new URL(string);
        return url.pathname;
    } catch (e) {
        return string;
    }
};

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        if (!(file instanceof Blob)) {
            reject(new TypeError("fileToBase64 expects a Blob/File"));
            return;
        }
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

export const downloadFileHandler = (url, fileName) => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "download";
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

